import useIsMounted from "../../../../../../hooks/use-is-mounted";
import React, {useMemo} from "react";
import {deepEqual} from "../../../../../../../core/services/utils/utils";
import Api from "../../../../../../../core/services/api/api";
import {OutlinedInputForm} from "../../../../../../components/base/input/outlined_input";
import SaveOrRollback from "../../../../../../components/app-specific/save-or-rollback";
import {Box, Paper, Typography} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";


const QuoteBypassSection = ({
                                required,
                                values,
                                initialValues,
                                form,
                                submitting,
                                customerId,
                                setBypass,
                                deleting,
                            }) => {
    const isMounted = useIsMounted();

    const isShowingSave = useMemo(() => !!(
        !deepEqual(
            {
                periodDays: values.periodDays,
                permittedTimes: values.permittedTimes
            },
            {
                periodDays: initialValues.periodDays,
                permittedTimes: initialValues.permittedTimes
            }
        )
        && !isNaN(parseInt(values.periodDays))
        && !isNaN(parseInt(values.permittedTimes))
    ), [values, initialValues])

    /**
     * Rollbacks the values of the bypass section for the customer to their initial values.
     * @param form {any}
     * @param initialValues {any}
     */
    const rollback = (form, initialValues) => {
        form.change('periodDays', initialValues.periodDays)
        form.change('permittedTimes', initialValues.permittedTimes)
    }

    /**
     * Calls the api for updating or creating the customer bypass information.
     *
     * @param periodDays {number}
     * @param permittedTimes {number}
     * @param setLoading {function}
     */
    const changeBypass = (periodDays, permittedTimes, setLoading) => {
        setLoading(true);
        const forApi = {
            periodDays: periodDays,
            permittedTimes: permittedTimes,
            customerId: customerId,
        }
        Api.saveQuoteBypassRuleForCustomer(forApi).then((response) => {
            if (!isMounted()) return;
            if (response?.resultFlag) {
                setBypass(prevState => ({
                    ...prevState,
                    periodDays: periodDays,
                    permittedTimes: permittedTimes,
                }))
            }
            setLoading(false);
        })
    }

    return (
        <>
            <Paper sx={{padding: 2, display: 'flex', flexDirection: 'column', position: 'relative', height: '100%', gap: 3}}>
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2}}>
                    <Typography variant={'subtitle1'} fontWeight={600}>
                        Quote Bypass Settings
                    </Typography>
                </Box>
                <Grid2 container spacing={2}>
                    <Grid2 xs={12} lg={5}>
                        <OutlinedInputForm
                            label={'Period (days)'}
                            name={`periodDays`}
                            type={'number'}
                            required={required.periodDays}
                            value={values?.periodDays ?? ''}
                            onChange={(e) => (!e.target.value && form.change(e.target.name, '')) || (e.target.value && !isNaN(parseInt(e.target.value)) && form.change(e.target.name, Math.max(parseInt(e.target.value), 0)))}
                        />
                    </Grid2>
                    <Grid2 xs={12} lg={7}>
                        <OutlinedInputForm
                            label={'Permitted count'}
                            name={`permittedTimes`}
                            type={'number'}
                            required={required.permittedTimes}
                            value={values?.permittedTimes ?? ''}
                            onChange={(e) => (!e.target.value && form.change(e.target.name, '')) || (e.target.value && !isNaN(parseInt(e.target.value)) && form.change(e.target.name, Math.max(parseInt(e.target.value), 0)))}
                        />
                    </Grid2>
                    <Grid2 xs={12}>
                        <SaveOrRollback
                            column={false}
                            show={isShowingSave && !deleting}
                            onRollback={() => rollback(form, initialValues)}
                            onSave={(setLoading) => !submitting && changeBypass(parseInt(values.periodDays), parseInt(values.permittedTimes), setLoading)}
                        />
                    </Grid2>
                </Grid2>
            </Paper>
        </>
    );
}

export default QuoteBypassSection;